/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { fireDB } from '../../../../Backend/Firebase/FirebaseConfigData'; // Import your Firebase config
import { collection, getDocs } from 'firebase/firestore'; // Firestore methods for fetching data
import * as XLSX from 'xlsx'; // Import XLSX library to handle Excel file generation

const Certificatedata = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [certificateData, setCertificateData] = useState<any[]>([]); // State to hold certificate data

  // Fetch data from Firestore on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(fireDB, 'Certificates')); // Assuming data is under 'Certificates' collection
        const data: any[] = [];
        querySnapshot.forEach((doc) => {
          data.push({ ...doc.data(), id: doc.id });
        });
        setCertificateData(data); // Store data in state
      } catch (error) {
        console.error('Error fetching data: ', error);
      }
    };

    fetchData();
  }, []);

  // Function to convert data to Excel and trigger download
  const downloadExcel = () => {
    // Prepare data for Excel export
    const exportData = certificateData.map((data) => ({
      'Batch Name': data.batchName,
      'Course Name': data.coursename,
      'Total Duration': data.totalduration,
      'Completion Month': data.completionmonth,
      'Completion Year': data.completionyear,
      'Date of Issue': data.currentDate,
      'Student Name': data.name,
      'Unique ID': data.uid,
    }));

    // Create a worksheet from the data
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Create a workbook and append the worksheet to it
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Certificate Data');

    // Trigger the download of the Excel file
    XLSX.writeFile(wb, 'certificate_data.xlsx');
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-white to-blue-50 py-8">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <h1 className="text-5xl font-bold text-center text-gray-800 mb-12">Certificate Data</h1>

        {/* Download Button */}
        <div className="mb-6 text-center">
          <button
            onClick={downloadExcel}
            className="bg-green-800 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg shadow-md transition-all duration-300"
          >
            Download Data as Excel
          </button>
        </div>

        {/* Table displaying the fetched certificate data */}
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto border-collapse border border-gray-300 shadow-lg rounded-lg">
            <thead>
              <tr className="bg-gradient-to-r from-green-400 to-green-600 text-black">
               
                <th className="px-6 py-3 text-left text-xl font-semibold">Course Name</th>
                <th className="px-6 py-3 text-left text-xl font-semibold">Total Duration</th>
                <th className="px-6 py-3 text-left text-xl font-semibold">Completion Month</th>
                <th className="px-6 py-3 text-left text-xl font-semibold">Completion Year</th>
                <th className="px-6 py-3 text-left text-xl font-semibold">Date of Issue</th>
                <th className="px-6 py-3 text-left text-xl font-semibold">Student Name</th>
                <th className="px-6 py-3 text-left text-xl font-semibold">Unique ID</th>
              </tr>
            </thead>
            <tbody>
              {/* Loop through certificateData and display each row */}
              {certificateData.map((data) => (
                <tr key={data.id} className="hover:bg-gray-100 transition-all duration-300">
                 
                  <td className="px-6 py-4 text-lg text-gray-800 border-b">{data.coursename}</td>
                  <td className="px-6 py-4 text-lg text-gray-800 border-b">{data.totalduration}</td>
                  <td className="px-6 py-4 text-lg text-gray-800 border-b">{data.completionmonth}</td>
                  <td className="px-6 py-4 text-lg text-gray-800 border-b">{data.completionyear}</td>
                  <td className="px-6 py-4 text-lg text-gray-800 border-b">{data.currentDate}</td>
                  <td className="px-6 py-4 text-lg text-gray-800 border-b">{data.name}</td>
                  <td className="px-6 py-4 text-lg text-gray-800 border-b">{data.uid}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Certificatedata;
